RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    views.TimezonePicker = RivalIQ.views.ItemView.extend({
        template: '#timezoneChangePicker',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            modal: '.modal',
            saveBtn: '.x-save',
            select: 'select'
        },

        triggers: {
            'click @ui.saveBtn': 'save'
        },

        behaviors: {
            FormValidator: {
                bindModel: false
            },
            AttributeBuilder: {}
        },

        onAttach: function () {
            const me = this;

            const now = new Date();
            const options = _.map(moment.tz.names(), function (id) {
                return {
                    id: id,
                    name: RivalIQ.utils.timezone.getDisplayName(id, now)
                };
            });

            let value;
            me.ui.select.selectize({
                selectOnTab: true,
                labelField: 'name',
                searchField: 'name',
                valueField: 'id',
                noEmptySelection: true,
                options: options,
                items: [me.model.get('timezone')],
                wrapperClass: 'riq-select',
                inputClass: 'riq-select-input',
                dropdownClass: 'riq-select-dropdown',
                dropdownContentClass: 'riq-select-dropdown-content',
                onDropdownOpen: function (dropdown) {
                    const selectize = me.ui.select[0].selectize;
                    dropdown.find('[data-toggle="popover"]').popover();
                    value = selectize.getValue();
                    selectize.clear(true);
                },
                onDropdownClose: function () {
                    const selectize = me.ui.select[0].selectize;
                    const currentValue = selectize.getValue();
                    if (!currentValue) {
                        selectize.setValue(value, true);
                    }
                }
            });
        },

        onSave: function () {
            const me = this;

            me.formAttrs.prevTimezone = me.model.get('timezone');
            me.model.set(me.formAttrs);
            me.ui.modal.modal('hide');

            const onSaved = me.getOption('onSaved');
            if (onSaved) {
                onSaved();
            }
        }
    });

}, window.moment);
